import script from "./SharedBoxList.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBoxList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/share.css?vue&type=style&index=0&id=7a5d6e5a&scoped=true&lang=css&external"
import "./SharedBoxList.vue?vue&type=style&index=1&id=7a5d6e5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a5d6e5a"]])

export default __exports__